import {
	type BettingInsightsResultAttribute,
	type EsIndex,
} from '~/configuration/betting-insights/types';
import { type SplitAtColon } from '~/types/SplitAtColon';

export function splitFacetFilter<
	TIndex extends EsIndex,
	T extends `${BettingInsightsResultAttribute<TIndex>}:${string}`,
>(value: T): SplitAtColon<T, BettingInsightsResultAttribute<TIndex>> {
	const [first, ...rest] = value.split(':');
	return [
		first as SplitAtColon<T, BettingInsightsResultAttribute<TIndex>>[0],
		...rest,
	] as SplitAtColon<T, BettingInsightsResultAttribute<TIndex>>;
}
